import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from 'react-autocomplete'

import '../SearchField.scss'
import { isNullOrUndefined } from '../../../utils/general'

export default class LocationSelector extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      location: props.location,
      locationSearchResults: props.location ? this.findMatchingLocations(props.location, props.locations) : []
    }
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    location: PropTypes.string,
    locations: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool.isRequired,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
    alignRight: PropTypes.bool
  }

  render() {
    return (
      <div className="group">
        <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor="location-autocomplete">
          {this.props.name}
          {this.props.required ? ' *' : null}
        </label>
        <div className="input-wrapper">
          <Autocomplete
            wrapperStyle={{ display: 'block' }}
            value={!isNullOrUndefined(this.state.location) ? this.state.location : ''}
            inputProps={{
              disabled: this.props.readOnly === true,
              name: this.props.fieldName,
              id: `${this.props.fieldName}-autocomplete`,
              className: `input-field ${this.props.error ? 'error' : ''}`
            }}
            items={this.state.locationSearchResults}
            getItemValue={item => item}
            onSelect={this.handleLocationSearchResultSelected}
            onChange={this.handleSearchLocationInputChange}
            renderItem={this.renderLocationSearchResultsListItem}
            renderMenu={this.renderSearchResultsList}
          />
        </div>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  /**
   * When user selects location from location search results
   * @param location
   */
  handleLocationSearchResultSelected = location => {
    this.setState({ location: location })
    this.props.onChange(location, this.props.fieldName)
  }

  /**
   * Handle change of the location search input
   * @param event
   * @param input
   */
  handleSearchLocationInputChange = (event, input) => {
    this.setState({ location: input, loading: true })

    // Fetch search results based on input query
    if (input && input.length >= 1) {
      this.setState({ locationSearchResults: this.findMatchingLocations(input, this.props.locations), loading: false })
    }

    this.props.onChange(input, this.props.fieldName)
  }

  findMatchingLocations = (searchTerm, locations) => {
    return locations ? locations.filter(l => l.toLowerCase().includes(searchTerm.toLowerCase())) : []
  }

  /**
   * Render location search result list
   * @param items
   * @param value
   */
  renderSearchResultsList = (items, value) => {
    return (
      <div className={`search-result-menu ${this.props.alignRight ? 'align-right' : ''}`}>
        {value === '' ? (
          <div style={{ padding: 6 }}>Search by location name</div>
        ) : this.state.loading ? (
          <div style={{ padding: 6 }}>Loading...</div>
        ) : items.length === 0 ? (
          <div style={{ padding: 6 }}>No matches for {value}</div>
        ) : (
          this.renderSearchResultsListCategoryHeader(items)
        )}
      </div>
    )
  }

  /**
   * Render category headers in ship search results list
   * @param items
   */
  renderSearchResultsListCategoryHeader(items) {
    return items.map((item, index) => {
      const text = item.props['data-location-name']
      if (index === 0 || items[index - 1].props['data-location-name'].charAt(0) !== text.charAt(0)) {
        return [
          <div key={index} className="item-category-header">
            {text.charAt(0)}
          </div>,
          item
        ]
      } else {
        return item
      }
    })
  }

  /**
   * Render location search result list item
   * @param location
   * @param isHighlighted
   */
  renderLocationSearchResultsListItem = (location, isHighlighted) => {
    return (
      <div
        className={isHighlighted ? 'item highlighted' : 'item'}
        key={location}
        data-location-name={location}
        id={location.name}
      >
        <div className="row name">
          <span className="label" />
          <span className="value">{location}</span>
        </div>
      </div>
    )
  }
}
